import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.unshift.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
//Component needed cause of variation with ThirdPartySelector
// property id_user forced for future adding wine to existing order,
// maybe others in future
// comment to be evolutive, one day if more than 2-3 variations, just say "needed cause too much variations" ...
import { request } from "@/js/http/http_request";
import { getUserLogged, isConsultantOrHolding, isSalesman, isHolding } from "@/js/http/auth.js";
import * as orderHandler from "@/js/order/order.js";
import { getCurrencyUser, setCurrencyUsedForCartAndExplore, getIdCurrencyUsedForCartAndExplore } from "@/js/currency/currencies.js";
import { getFullNameUser } from "@/js/user/user.js";
import { filterVAutocomplete, getErrorData, handleErrorData, ERROR_DATA } from "@/js/forms.js";
import { listUserGroups } from "@/js/lists.ts";
import confirmationDialog from "@/components/modal/ConfirmationDialog.vue";
import SendInvitationAsConsultantModal from "@/components/user/SendInvitationAsConsultantModal.vue";
import ErrorModal from "@/components/modal/ErrorModal.vue";
export default {
  components: {
    confirmationDialog: confirmationDialog,
    SendInvitationAsConsultantModal: SendInvitationAsConsultantModal,
    ErrorModal: ErrorModal
  },
  props: {
    loggedUserData: Object,
    disabled: Boolean,
    userTargetId: Number
  },
  data: function data() {
    return {
      thirdPartyUserSelected: null,
      lastThirdPartyUserSelected: null,
      thirdPartyUserList: [],
      isLoading: true,
      boolRenderer: false,
      isExtendedList: false,
      managedExceptions: {
        error: {
          EMPTY_BASKETY_WRONG_STATUS: "There is a data incoherence. You should refresh the page. Else close open tabs, sign out et sign in again."
        }
      },
      ERROR_DATA: ERROR_DATA
    };
  },
  computed: {
    inputPlaceholder: function inputPlaceholder() {
      var _this$thirdPartyUserS;
      var isLoading = this.isLoading;
      var isUserSelected = !!((_this$thirdPartyUserS = this.thirdPartyUserSelected) !== null && _this$thirdPartyUserS !== void 0 && _this$thirdPartyUserS.id_user);
      if (!isHolding(this.loggedUserData)) {
        if (isLoading) {
          return isUserSelected ? "Loading selected customer" : "Loading list of customers";
        } else {
          return "Search for a customer";
        }
      } else {
        if (isLoading) {
          return isUserSelected ? "Loading selected" : "Loading list";
        } else {
          return "Search";
        }
      }
    },
    canRestrictList: function canRestrictList() {
      var _this$thirdPartyUserS2;
      return isSalesman(this.loggedUserData) && this.isExtendedList && (!this.thirdPartyUserSelected || ((_this$thirdPartyUserS2 = this.thirdPartyUserSelected.salesmanFollower) === null || _this$thirdPartyUserS2 === void 0 ? void 0 : _this$thirdPartyUserS2.id_user) === +this.loggedUserData.idUser);
    }
  },
  created: function created() {
    var _this2 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return _this2.fetchList();
          case 2:
            if (!_this2.userTargetId) {
              _this2.thirdPartyUserSelected = orderHandler.getThirdPartyUserSelected();
              _this2.lastThirdPartyUserSelected = _this2.thirdPartyUserSelected;
            }
            if (!(isSalesman(_this2.loggedUserData) && +_this2.thirdPartyUserSelected > 0)) {
              _context.next = 7;
              break;
            }
            if (_this2.thirdPartyUserList.some(function (x) {
              return x.id_user == _this2.thirdPartyUserSelected;
            })) {
              _context.next = 7;
              break;
            }
            _context.next = 7;
            return _this2.fetchList(true);
          case 7:
            if (_this2.userTargetId !== null) {
              _this2.thirdPartyUserSelected = _this2.thirdPartyUserList.find(function (x) {
                return x.id_user == userTargetId;
              });
              _this2.lastThirdPartyUserSelected = _this2.thirdPartyUserSelected;
            }
          case 8:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    openSendInvitationAsConsultantModal: function openSendInvitationAsConsultantModal() {
      this.$refs.SendInvitationAsConsultantModal.open();
    },
    selectThirdPartyUserConfirm: function selectThirdPartyUserConfirm() {
      var _this$lastThirdPartyU,
        _this3 = this;
      if (((_this$lastThirdPartyU = this.lastThirdPartyUserSelected) === null || _this$lastThirdPartyU === void 0 ? void 0 : _this$lastThirdPartyU.id_user) != 0 && orderHandler.getCurrentOrder()) {
        this.$refs.confirmationDialog.open("CHANGE USER", "Are you sure you want to change the user? All items in the cart will be removed!").then(function (confirm) {
          if (confirm) {
            _this3.selectThirdPartyUser();
          } else {
            _this3.boolRenderer = !_this3.boolRenderer;
            _this3.thirdPartyUserSelected.id_user = _this3.lastThirdPartyUserSelected.id_user;
          }
        });
      } else {
        this.selectThirdPartyUser();
      }
    },
    selectThirdPartyUser: function selectThirdPartyUser() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _this, currentOrder, _data, newCurrency, response, _yield$orderHandler$f, data;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this = _this4;
              _this4.$EventBus.$emit("loading", true);
              if (_this4.userTargetId !== null) {
                _this4.thirdPartyUserSelected = _this4.userTargetId;
              }
              currentOrder = orderHandler.getCurrentOrder();
              if (!currentOrder) {
                _context2.next = 10;
                break;
              }
              _data = {
                orderId: +currentOrder.id_order,
                userId: +_this4.loggedUserData.idUser
              };
              _context2.next = 8;
              return request("/v1/basket/".concat(currentOrder.id_order), "delete", _data, true, "api").catch(function (e) {
                var errorData = getErrorData(e, _this.managedExceptions);
                handleErrorData(_this, errorData);
                _this.$EventBus.$emit("loading", false);
                throw e;
              });
            case 8:
              orderHandler.removeOrderFromStorage();
              _this4.$EventBus.$emit("BasketRemoved");
            case 10:
              _this4.lastThirdPartyUserSelected = _this4.thirdPartyUserSelected;
              newCurrency = null;
              if (!_this4.thirdPartyUserSelected) {
                _context2.next = 16;
                break;
              }
              newCurrency = _this4.thirdPartyUserSelected.default_currency;
              _context2.next = 20;
              break;
            case 16:
              _context2.next = 18;
              return getCurrencyUser();
            case 18:
              response = _context2.sent;
              newCurrency = response.data.currency;
            case 20:
              if (getIdCurrencyUsedForCartAndExplore() !== newCurrency) {
                setCurrencyUsedForCartAndExplore(newCurrency);
                _this4.$EventBus.$emit("CurrencyUpdated", newCurrency);
              }
              orderHandler.setThirdPartyUserSelected(_this4.thirdPartyUserSelected);
              _context2.next = 24;
              return orderHandler.fetchBasket();
            case 24:
              _yield$orderHandler$f = _context2.sent;
              data = _yield$orderHandler$f.data;
              if (!!data) {
                orderHandler.setCurrentOrder(data);
                _this4.$EventBus.$emit("update-cart");
              }
              orderHandler.refreshCategoryUser(_this4);
              _this4.$emit("changeUser");
              _this4.$EventBus.$emit("loading", false);
            case 30:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    fetchList: function fetchList() {
      var _arguments = arguments,
        _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var forceEntireList, defaultCurrency, userHolding, response, values;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              forceEntireList = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : false;
              _this5.isLoading = true;
              defaultCurrency = "";
              if (!isHolding(_this.loggedUserData)) {
                _context3.next = 8;
                break;
              }
              _context3.next = 6;
              return getUserLogged();
            case 6:
              userHolding = _context3.sent;
              defaultCurrency = userHolding.default_currency;
            case 8:
              _context3.next = 10;
              return request("/v1/third-party-users" + (forceEntireList ? "?forceEntireList=true" : ""), "get", {}, true, "api").catch(function (e) {
                var errorData = getErrorData(e, "Unable to get list of customers", true);
                handleErrorData(_this, errorData);
                _this.isLoading = false;
                throw e;
              });
            case 10:
              response = _context3.sent;
              values = _toConsumableArray(response.data.values);
              _this5.thirdPartyUserList = [];
              values.forEach(function (user) {
                var _listUserGroups$find;
                var fullName = !isHolding(_this5.loggedUserData) ? getFullNameUser(user) + " - " + user.delivery_address.country.iso_code + " " + ((_listUserGroups$find = listUserGroups.find(function (x) {
                  return x.id === user.user_group.toUpperCase();
                })) === null || _listUserGroups$find === void 0 ? void 0 : _listUserGroups$find.name) + " (" + user.login + ")" : getFullNameUser(user);
                _this5.thirdPartyUserList.push(_objectSpread(_objectSpread({}, user), {}, {
                  full_name: fullName
                }));
              });
              _this5.thirdPartyUserList.sort(function (a, b) {
                return a.full_name.localeCompare(b.full_name);
              });
              if (isHolding(_this5.loggedUserData) && !_this5.thirdPartyUserList.some(function (x) {
                return x.id_user == _this5.loggedUserData.idUser;
              })) {
                _this5.thirdPartyUserList.unshift({
                  id_user: _this5.loggedUserData.idUser,
                  full_name: "All group",
                  email: "",
                  company: "",
                  default_currency: defaultCurrency,
                  active: true
                });
              }
              _this5.isExtendedList = forceEntireList;
              _this5.isLoading = false;
            case 18:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    filterVAutocomplete: filterVAutocomplete,
    isConsultantOrHolding: isConsultantOrHolding,
    isSalesman: isSalesman
  }
};